.dropdown-form-field{width:100%}.dropdown-icon{padding:0 6px 0 0!important}
/*# sourceMappingURL=dropdown.component-2NJRACU5.css.map */
